import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import changeDateFormat from "../utils"
import projectStyles from '../../styles/Projects.module.css'

export default function ProjectPubPoints(props){
    return (
        <Row>
            <Col>
                <p className={projectStyles.published}>{changeDateFormat(props.date)}</p>
            </Col>
            <Col className="text-end">
                <p className={projectStyles.points}>{props.points} pts</p>
            </Col>
        </Row>
    )
}